import { useEffect, useState } from 'react'

/**
 * Whether the browser says it has a network. `navigator.onLine` can be true on a network that
 * reaches nothing, so this only ever adds an explanation; a request still decides what happened.
 */
export function useOnline(): boolean {
  const [online, setOnline] = useState(() =>
    typeof navigator === 'undefined' ? true : navigator.onLine,
  )
  useEffect(() => {
    const update = () => setOnline(navigator.onLine)
    window.addEventListener('online', update)
    window.addEventListener('offline', update)
    update()
    return () => {
      window.removeEventListener('online', update)
      window.removeEventListener('offline', update)
    }
  }, [])
  return online
}
